import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Baseline } from 'projects/oct-report-lib/src/public-api';

const headers = {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    'Access-Control-Allow-Origin': '*',
};

@Injectable()
export class ReportBaselineDataService extends DefaultDataService<any> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
        super('Baseline', http, httpUrlGenerator);
    }

    override getWithQuery(params: { msp: string; tenant: string }): Observable<Baseline[]> {
        return this.http
            .get<Baseline[]>(`/api/report/tenant/${params.tenant}/baselines`, {
                headers: {
                    ...headers,
                    'msp-id': params.msp,
                    'tenant-id': params.tenant,
                },
            })
            .pipe(
                map((res) => res),
                catchError((err) => {
                    console.log('[error] ReportBaselineDataService:', JSON.stringify(err));
                    return of(err);
                }),
            );
    }
}
